import request from "@utils/request";

const state = "storeEmployees";
const baseUrl = "users/store-employees";

const list = async (customConfig?: any) => {
  return await request({
    url: baseUrl,
    method: "GET",
    config: { store: { action: "set", key: state, ...customConfig } },
    authorization: true,
  });
};

const find = async (id: number) => {
  return await request({
    url: `${baseUrl}/${id}`,
    method: "GET",
    authorization: true,
  });
};

const create = async (data: any) => {
  return await request({
    url: baseUrl,
    method: "POST",
    data,
    authorization: true,
  });
};

const update = async (id: number, data: any) => {
  return await request({
    url: `${baseUrl}/${id}`,
    method: "PATCH",
    data,
    authorization: true,
  });
};

const remove = async (id: number) => {
  return await request({
    url: `${baseUrl}/${id}`,
    method: "DELETE",
    authorization: true,
  });
};

export default { list, find, create, update, remove };
